import { tns } from 'tiny-slider/src/tiny-slider'

export default new class ClientsSlider {
    constructor() {
        this.sliderWrap = '#our-clients-slider'
        this.controlsContainer = '#our-clients-controls'

        this.init()
    }

    init() {
        var slider = tns({
            container: this.sliderWrap,
            items: 1,
            nav: false,
            controlsContainer: this.controlsContainer,
            slideBy: 'page'
        });
    }
}